import { useState } from "react";
import { Plus, Pencil, Trash2, Moon, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { thumb } from "../../lib/api";
import { LangBadge } from "../Flags";
import { SongForm } from "./SongForm";

export const SongsTab = ({ songs, themes, call, reload }) => {
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);
  const themeName = (slug) => themes.find((t) => t.slug === slug)?.name || slug;

  const save = async (body) => {
    if (editing) await call("put", `/admin/songs/${editing.id}`, body);
    else await call("post", "/admin/songs", body);
    toast.success("Comptine enregistrée");
    reload();
  };
  const remove = async (s) => {
    if (!window.confirm(`Supprimer « ${s.title} » ?`)) return;
    try { await call("delete", `/admin/songs/${s.id}`); } catch { return; }
    toast.success("Comptine supprimée");
    reload();
  };

  return (
    <div>
      <Button onClick={() => { setEditing(null); setOpen(true); }} className="rounded-full bg-[#4CC417] hover:bg-[#3fae10]" data-testid="admin-add-song-btn">
        <Plus className="w-4 h-4 mr-1" /> Ajouter une comptine
      </Button>
      <ul className="mt-5 space-y-3" data-testid="admin-songs-list">
        {songs.map((s) => (
          <li key={s.id} data-testid={`admin-song-${s.slug}`} className="flex items-center gap-3 rounded-[20px] bg-white p-3 shadow-sm">
            <img src={thumb(s.youtube_id)} alt="" className="h-14 w-24 shrink-0 rounded-xl object-cover" />
            <div className="min-w-0 flex-1">
              <p className="font-bold leading-tight break-words">{s.title}</p>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs">
                <LangBadge lang={s.language} />
                <span className="rounded-full bg-[#FFF9F2] px-2 py-1 font-semibold">{themeName(s.theme)}</span>
                {s.calm && <span className="inline-flex items-center gap-1 rounded-full bg-[#1E2A5A] px-2 py-1 font-semibold text-white"><Moon className="w-3 h-3" /> Calme</span>}
                {!s.published && <span className="inline-flex items-center gap-1 rounded-full bg-gray-200 px-2 py-1 font-semibold"><EyeOff className="w-3 h-3" /> Brouillon</span>}
                {!s.lyrics?.trim() && <span className="rounded-full bg-[#FFD21F]/40 px-2 py-1 font-semibold">Sans paroles</span>}
              </div>
            </div>
            <Button variant="ghost" size="icon" aria-label="Modifier" data-testid={`admin-edit-song-${s.slug}`} onClick={() => { setEditing(s); setOpen(true); }}><Pencil className="w-5 h-5" /></Button>
            <Button variant="ghost" size="icon" aria-label="Supprimer" data-testid={`admin-delete-song-${s.slug}`} onClick={() => remove(s)}><Trash2 className="w-5 h-5 text-[#F0303A]" /></Button>
          </li>
        ))}
      </ul>
      <SongForm open={open} onOpenChange={setOpen} song={editing} themes={themes} onSave={save} call={call} />
    </div>
  );
};
